import React, { useCallback, useEffect, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  resetGlobeLoader,
  showLoader,
} from "../../redux/loaderActions";
import { LEGACY_STAFF_URL } from "../../Enums/LegacyRedirection";
import { getFirmById } from "../../Services/Firm";
import IFirm from "../../interfaces/models/IFirm";
import { setCurrentFirm } from "../../redux";

const legacyTabs: Record<string, string> = {
	dashboard: 'wsg_admin2.asp',
	professionals: 'wsg_firmprofessionals.asp',
	referrals: 'admin_manage_referrals.asp',
	groupparticipants: 'wsg_admin15.asp?action=detailfirm&f=1',
	events: 'manage_events.asp?fromadmin=true',
};

const LEGACY_LOADER_MAX_WAIT_MS = 30000;

const GroupsPage = () => {
	const { id } = useParams();
	const iframeRef = useRef(null);
	const location = useLocation();
	const dispatch = useDispatch();
	const [token, setToken] = React.useState<string | null>(null);
	const loaderReleaseTimerRef = useRef<ReturnType<typeof setTimeout> | null>(
		null,
	);
	
	useEffect(() => {
		const tokenCookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith('token='))?.trim().substring(6);
		if(tokenCookie) {
			setToken(tokenCookie);
		}
	}, []);

	const clearLoaderReleaseTimer = useCallback(() => {
		if (loaderReleaseTimerRef.current !== null) {
			clearTimeout(loaderReleaseTimerRef.current);
			loaderReleaseTimerRef.current = null;
		}
	}, []);

	const completeLegacyLoad = useCallback(() => {
		clearLoaderReleaseTimer();
		resetGlobeLoader();
	}, [clearLoaderReleaseTimer]);

	const beginLegacyLoad = useCallback(() => {
		clearLoaderReleaseTimer();
		showLoader();
		loaderReleaseTimerRef.current = setTimeout(() => {
			loaderReleaseTimerRef.current = null;
			resetGlobeLoader();
		}, LEGACY_LOADER_MAX_WAIT_MS);
	}, [clearLoaderReleaseTimer]);

	useEffect(() => {
		return () => {
			clearLoaderReleaseTimer();
			resetGlobeLoader();
		};
	}, [clearLoaderReleaseTimer]);

	const getFirmInfo = async (id: string) => {
    const firm:IFirm = await getFirmById(id);
    dispatch(setCurrentFirm(firm));
		return firm;
  };

	useEffect(() => {
		if(!id || !token) {
		  return;
		}
		let cancelled = false;

		void getFirmInfo(id)
			.then(firm => {
				if (cancelled || !iframeRef.current) {
				  return;
				}
				resetGlobeLoader();
				beginLegacyLoad();
				const iframe = iframeRef.current as HTMLIFrameElement;
				const path = location.pathname.toLowerCase();
				const section = path.split('/')[2];
				const legacyTab = section ? legacyTabs[section] : undefined;
				if (!legacyTab) {
					completeLegacyLoad();
					return;
				}
				const legacyPath = new URL(`${LEGACY_STAFF_URL}/${legacyTab}`);
				legacyPath.searchParams.append('hide-navigation', 'true');
				legacyPath.searchParams.append('pcomp', firm.legacyId as string);

				if (token) {
					legacyPath.searchParams.append('token', token);
				}

				iframe.src = legacyPath.toString();
		
				iframe.onload = () => { completeLegacyLoad(); };
				iframe.onerror = () => { completeLegacyLoad(); };
			})
			.catch(() => {
				if (!cancelled) {
					completeLegacyLoad();
				}
			});

		return () => {
			cancelled = true;
		};
	}, [location.pathname, id, token, beginLegacyLoad, completeLegacyLoad]);

  return (
    <>
      <div className="min-h-screen w-full flex items-center align-middle justify-center">
        <iframe ref={iframeRef} className="min-h-screen w-full" title="Legacy"></iframe>
      </div>
    </>
  );
};

export default GroupsPage;
